import React from 'react';
import { StatusTag } from '@monorepo/ui-kit';
import { DEAL_STATUS } from '@monorepo/dictionary';
import styles from './index.module.css';

const DealStatusTag: Component<{ status: number }> = ({ children, status }) => (
  <StatusTag className={styles[DEAL_STATUS[status]?.toLowerCase()] || ''}>
    {children}
  </StatusTag>
);

export default DealStatusTag;
